import RePasswordModal from '@/components/common/LoginRelatedComponent/component/Forget/components/RePasswordModal'
import SvgIcon from '@/components/common/SvgIcon'
import { MenuItemACS, MenuItemAdmin, MenuItemHRM } from '@/routes/MenuItem'
import ROUTER from '@/routes/ROUTER'
import { useAppSelector } from '@/shared/redux/hooks'
import { selectListTabs, setListTabs, setUserInfo } from '@/shared/redux/slices/appGlobal.slice'
import IdentityService from '@/shared/services/IdentityService'
import {
  STORAGE,
  clearLocalStorage,
  clearSessionStorage,
  getLocalStorage,
} from '@/shared/utils/storage'
import { hasPermission } from '@/shared/utils/utils'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Col, Divider, Menu, Row } from 'antd'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import '../popupStyle.scss'
import { StyleMenuAccount } from '../styles'

const MenuUser = () => {
  const { userInfo } = useSelector((state: any) => state?.appGlobal)
  const [rePasswordModal, setRePasswordModal] = useState(false)
  const isLogin = getLocalStorage(STORAGE.TOKEN)
  const dispatch = useDispatch()
  const listTabs = useAppSelector(selectListTabs)

  const navigate = useNavigate()
  const location = useLocation()
  const acsRoutesWithoutPrefix = [
    ROUTER.VI_PHAM,
    ROUTER.THONG_KE_VI_PHAM,
    ROUTER.DANH_SACH_VI_PHAM,
    ROUTER.NHAN_VIEN_VI_PHAM,
  ]

  const getActiveKey = (): string[] => {
    if (rePasswordModal) {
      return ['3']
    }
    const currentPath = location.pathname || ''
    const isAcsRoute =
      currentPath.startsWith('/acs') ||
      currentPath.includes('acs') ||
      acsRoutesWithoutPrefix.some((route) => currentPath.startsWith(route))
    if (currentPath.startsWith('/user') || currentPath.includes(ROUTER.THONG_TIN_TAI_KHOAN)) {
      return ['2']
    }
    if (isAcsRoute) {
      return ['4']
    }
    if (currentPath.startsWith('/hrm,') || currentPath.includes('hrm')) {
      return ['5']
    }
    if (currentPath !== '/') {
      return ['1']
    }
    return []
  }

  const activeKey = getActiveKey()

  const setShowListMenu = (list: any[], listTab: any[]): any[] | undefined => {
    if (!list?.length) return undefined
    return list
      ?.filter((x: any) => hasPermission(x?.tabid, listTab))
      ?.map((i: any) => {
        const children = setShowListMenu(i?.children, listTab)
        return { ...i, children }
      })
      ?.filter((item: any) => {
        if (item.children && item.children.length > 0) return true
        return !item.key?.startsWith('subkey')
      })
  }

  const hasAdminPermission = (): boolean => {
    const menuItemAdmin = MenuItemAdmin()
    const listMenuAdmin = setShowListMenu(menuItemAdmin, listTabs)
    return !!(listMenuAdmin && listMenuAdmin.length > 0)
  }

  const handleLogout = async () => {
    if (isLogin) {
      IdentityService.logout()
      clearLocalStorage()
      clearSessionStorage()
      dispatch(setUserInfo({}))
      dispatch(setListTabs([]))
      return navigate(ROUTER?.HOME)
    }
  }

  const findFirstValidRoute = (menuItems: any[]): string | null => {
    if (!menuItems || menuItems.length === 0) return null
    for (const item of menuItems) {
      if (item.children && item.children.length > 0) {
        const childRoute = findFirstValidRoute(item.children)
        if (childRoute) return childRoute
      } else if (item.key && typeof item.key === 'string' && !item.key.startsWith('subkey')) {
        return item.key
      }
    }
    return null
  }

  const comeStartPage = async (type: string): Promise<string> => {
    let menuItemAdmin = MenuItemAdmin()
    if (type === 'acs') {
      menuItemAdmin = MenuItemACS()
    }
    if (type === 'hrm') {
      menuItemAdmin = MenuItemHRM()
    }
    const listMenuAdmin = setShowListMenu(menuItemAdmin, listTabs)
    if (!listMenuAdmin || listMenuAdmin.length === 0) return ROUTER.HOME
    const firstValidRoute = findFirstValidRoute(listMenuAdmin)
    return firstValidRoute || ROUTER.HOME
  }

  return (
    <StyleMenuAccount>
      <div className="menu-account">
        <Menu className="dropdown-option" selectedKeys={activeKey}>
          <div className="account-infor">
            <Row gutter={[20, 8]} className="infor">
              <Col span={6}>
                <div className="text-center">
                  <Avatar
                    src={userInfo?.avatar}
                    size={52}
                    icon={<UserOutlined style={{ fontSize: '36px' }} />}
                  />
                </div>
              </Col>
              <Col span={18}>
                <div className="sumary-infor-user">
                  {!!userInfo?.fullName && (
                    <div className="account-name max-line1 fz-16 fw-600">{userInfo?.fullName}</div>
                  )}
                  {!!userInfo?.email && (
                    <div className="account-name max-line1">{userInfo?.email}</div>
                  )}
                </div>
              </Col>
            </Row>
            <Divider />
          </div>
          {hasAdminPermission() && (
            <>
              <Menu.Item
                key="1"
                onClick={async () => {
                  const startPage = await comeStartPage('admin')
                  navigate(startPage)
                }}
              >
                <div className="btn-function">
                  <SvgIcon name="config" />
                  <span className="fw-400">Quản trị hệ thống</span>
                </div>
              </Menu.Item>

              <Menu.Item
                key="4"
                onClick={async () => {
                  const startPage = await comeStartPage('acs')
                  navigate(startPage)
                }}
              >
                <div className="btn-function">
                  <SvgIcon name="accessControlSystem" />
                  <span className="fw-400">ACS</span>
                </div>
              </Menu.Item>
              <Menu.Item
                key="5"
                onClick={async () => {
                  const startPage = await comeStartPage('hrm')
                  navigate(startPage)
                }}
              >
                <div className="btn-function">
                  <SvgIcon name="humanGroup" />
                  <span className="fw-400">HRM</span>
                </div>
              </Menu.Item>
            </>
          )}
          <Menu.Item key="2" onClick={() => navigate(ROUTER.TONG_QUAN_CUA_TOI)}>
            <div className="btn-function">
              <SvgIcon name="user_login" />
              <span className="fw-400">Thông tin cá nhân</span>
            </div>
          </Menu.Item>

          <Menu.Item key="3" onClick={() => setRePasswordModal(true)}>
            <div className="btn-function strok-btn-function">
              <SvgIcon name="reset-pass" />
              <span className="fw-400">Đổi mật khẩu </span>
            </div>
          </Menu.Item>

          <Divider className="m-0" />

          <Menu.Item key="6" style={{ color: '#ED1117' }} onClick={handleLogout}>
            <div className="btn-logout">
              <SvgIcon name="logoutIcon" />
              Đăng xuất
            </div>
          </Menu.Item>
        </Menu>
      </div>

      {!!rePasswordModal && (
        <RePasswordModal
          rePasswordModal={rePasswordModal}
          handleCancel={() => setRePasswordModal(false)}
        />
      )}
    </StyleMenuAccount>
  )
}

export default MenuUser
